<template>
  <div class="topic-box"  :style="{'display': display}">
    <div class="topic-head">
      <span @click="backClick">返回</span>
    </div>
    <div class="topic-context" ref='topicbox'>
      <titleBar :topic-name="topicInfo.topicName" :topic-count="topicInfo.viewCount"></titleBar>
      <userInfoBar :user-name="topicInfo.author.authorName" :topic-time="topicInfo.answerTime"></userInfoBar>

      <div style="margin: 5px 10px; position: relative;">
        <markdownCode :txt="fanswerContext"></markdownCode>
      </div>

      <div class="topic-replyCount">
        全部回复({{freplyCount}})
      </div>
      <replyPanel :reply-child="discussInfo.child" :cur-reply-id="curReplyId" @eventReplyCancel="eventReplyCancel" @eventReleaseReply="releaseReply"></replyPanel>

      <navBar
          :total="discussInfo.total"
          :curpage="curpage"
          :pagesize="pagesize"
          @event-page-click="eventPageClick"></navBar>

      <div style="padding-top: 30px; padding-left:15px">你的回复</div>
      <markdownWin :author="topicInfo.author" @eventReleaseReply="releaseReply"></markdownWin>
      </div>
    </div>
</template>

<script>
import titleBar from "@/components/panel/titleBar";
import userInfoBar from "@/components/panel/userInfoBar";
import replyPanel from "@/components/panel/replyPanel";
import navBar from '@/components/panel/navBar';
import markdownCode from "@/components/common/markdownCode";
import markdownWin from "@/components/common/markdownWin"
import utils from "@/utils/utils";
import serviceApi from "@/utils/serviceApi";

export default {
  name: "replyPage",
  props:{
    isShow: Boolean,
  },
  data(){
    return{
      curReplyId:'',
      topicInfo:{
        topicId: "id",
        topicName: "小程序",
        answerTime: "2023-12-12",
        answerContext: "答案分享内容",
        likeCount: 10,
        replyCount:110,
        viewCount: 200,
        author:{
          authorId: "作者ID",
          authorName: "作者名称",
          authorIcon: "undefined"
        },
        summaryInfo: "附加信息"
      },
      curpage:1,
      pagesize: 5,
      discussInfo:{
        total: 10,
        child:[
          {
            replyId: '',
            author: {authorId:'',authorName:'',authorIcon:undefined},
            replyContext: '',
            replyTime: '',
            likeCount: 0,
            child:[]
          }
        ]
      },

    }
  },

  computed:{
    display:function (){
      if(this.isShow){
        return "block"
      }else{
        return "none";
      }
    },
    freplyCount:function (){
      return this.discussInfo.total
    },
    fanswerContext: function (){
      return decodeURI(this.topicInfo.answerContext) ;
    },
  },
  mounted() {

  },

  methods:{
    init(topicInfo){
      this.topicInfo = topicInfo;
      //更新查看
      serviceApi.updateTopics(
          {topicId:this.topicInfo.topicId, state: 'view' },
          ()=>{})

      serviceApi.loadReply(
          {
            topidid: this.topicInfo.topicId,
            curpage: this.curpage,
            pagesize: this.pagesize,
            },
          this.callback);
    },

    callback: function (resultData){
      this.discussInfo = resultData
    },

    backClick:function (){
      this.exShow = false;
      this.$emit('event-back');
    },
    eventPageClick:function(pageno){
      if(pageno > 0 &&
          pageno <= Math.ceil(this.discussInfo.total / this.pagesize)){
        this.curpage = pageno;
        serviceApi.loadReply(
          {
            topidid: this.topicInfo.topicId,
            curpage: this.curpage,
            pagesize: this.pagesize,
            },
          this.callback);
      }
    },
    eventReplyCancel: function (replyId){
      this.curReplyId = replyId
    },

    callbackReply: function (reply, replys){
      if (replys.length > 0){
       for(let i = 0, len = replys.length; i < len; i ++){
         if (replys[i].replyId == reply.preplyId){
           replys[i].child.unshift(reply);
           return;
         }else{
           this.callbackReply(reply, replys[i].child)
         }
       }
      }
    },
    //确定回复信息 opter insert  append
    releaseReply: function (htmlStr, opter){
      let reply = {
                  replyId: utils.guid(),
                  preplyId: this.curReplyId,
                  author: {authorId:'',authorName:'',authorIcon:undefined},
                  replyContext: htmlStr,
                  replyTime: '',
                  likeCount: 0,
                  child:[]
                  }

      serviceApi.UpdateReply(
          {
              topicId: this.topicInfo.topicId,
              replyId: reply.replyId,
              preplyId: opter == 'append' ? '': this.curReplyId,
              replyContext: encodeURI(reply.replyContext)
              },
          () =>{
              if(opter == 'append'){
                this.discussInfo.child.unshift(reply);
              }else{
                this.callbackReply(reply, this.discussInfo.child);
                this.curReplyId = '';
              }
          }
        )
    }
  },
  components:{
    userInfoBar,
    markdownCode,
    replyPanel,
    markdownWin,
    navBar,
    titleBar
  }
}
</script>

<style scoped>
.topic-box{
  position: relative;
  height: 100vh;
  background: #fff;
  color: #000;
}
.topic-head{
  background: #fff;
  border-bottom: 1px solid #eee;
  height: 50px;
  line-height:50px;
  padding-left:10px;
}
.topic-context{
  position: relative;
  height: calc(100vh - 50px);
  overflow-y:auto;
}



.topic-head span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: left;
  height: 30px;
  line-height: 30px;
  margin-left: 10px;
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #2e7eee;
}


.topic-replyCount{
  padding-top: 40px;
  padding-bottom: 10px;
  padding-left:10px;
  border-bottom: 1px solid #eee;
  color: #666;
}
</style>
